import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';
import { lightPalette, darkPalette } from './palette';

const componentOverrides = {
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'uppercase' as const,
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'uppercase' as const,
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      variant: 'standard' as const,
    },
  },
  MuiSelect: {
    defaultProps: {
      variant: 'standard' as const,
    },
  },
  MuiLink: {
    styleOverrides: {
      root: {
        textDecoration: 'underline',
      },
    },
  },
};

const buildTheme = (mode: 'light' | 'dark'): Theme => {
  const base = createTheme({
    palette: mode === 'light' ? lightPalette : darkPalette,
    typography: {
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    },
    components: componentOverrides,
  });
  return responsiveFontSizes(base);
};

export const lightTheme = buildTheme('light');
export const darkTheme = buildTheme('dark');
